// extracted by mini-css-extract-plugin
module.exports = {"gameOverText":"style_gameOverText__9L6S7","headline":"style_headline__eZosA"};